import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { listMutations } from './types';
import { apiProvider } from '../api';
import { NAME, CRUMB_LABEL_KEY } from '../constants';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SnPzn: [],
		VyrobekvozOzn: [],
		SnDruh: [],
	},
	filter: {
		SnPzn: null as string | null,
		VyrobekvozOzn: null as string | null,
		Tablpozice: null as string | null,
		TablpoziceText: null as string | null,
		SnNr: null as string | null,
		Text: null as string | null,
		SnDruh: null as string | null,
		PlatnostOdDat: null as Date | null,
		PlatnostDoDat: null as Date | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {
		[listMutations.TABULKOVA_POZICE_SELECT_MAPPER](state, { data }) {
			state.filter.Tablpozice = data.value;
			state.filter.TablpoziceText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
